import { Injectable } from '@angular/core';
import { StorageService } from '@app/services/storage';
import { GeneralApiService, StatusApi } from '@global-service/api';
import { SociedadSimple } from '../interfaces';

@Injectable()
export class SociedadesService {
  constructor(private readonly generalApi: GeneralApiService, private readonly storageService: StorageService) {}
  get(loading?: StatusApi) {
    return this.generalApi.callApi<SociedadSimple[]>('get', `/empresa/${this.storageService.getEmpresaID()}/sociedades`, {
      loading
    });
  }
}
